import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Fornecimento Direto",
  path: "/merenda/merfornecimentodireto",
  name: "merfornecimentodireto",
  component: () => import("@/views/merenda/merfornecimentodireto/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.FORNECIMENTODIRETONOVO_MENU_1000400459],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Fornecimento Direto",
  path: "/merenda/merfornecimentodireto/cadastro/:id?",
  parent: "merfornecimentodireto",
  name: "merfornecimentodireto_create",
  component: () => import("@/views/merenda/merfornecimentodireto/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.FORNECIMENTODIRETONOVO_MENU_1000400459],
  },
  goesToMenu: true,
 },
 {
  description: "Materiais do Fornecimento Direto",
  path: "/merenda/merfornecimentodireto/:id/itens",
  parent: "merfornecimentodireto",
  name: "merfornecimentodireto_itens",
  component: () => import("@/views/merenda/merfornecimentodireto/Itens.vue"),
  meta: {
   permissions: [eTipoPermissao.FORNECIMENTODIRETONOVO_MENU_1000400459],
  },
  goesToMenu: false,
 },
 {
  path: "/merenda/merfornecimentodireto/:ano(\\d+)",
  redirect: (to: any) => ({
   name: "merfornecimentodireto",
   query: {
    ...to.query,
    ano: String(to.params.ano),
   },
  }),
 },
]
